import TaskDetailsView from "../../components/tasks/TaskDetailsView";
import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Badge } from "react-bootstrap";
import { FcNext, FcPrevious } from "react-icons/fc";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vs } from "react-syntax-highlighter/dist/esm/styles/prism";

import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaCaretDown,
  FaCaretUp,
  FaCheckCircle,
  FaCodeBranch,
  FaDotCircle,
  FaExclamationCircle,
  FaFlag,
  FaHourglassHalf,
  FaPlus,
  FaSearch,
  FaUser,
} from "react-icons/fa";
import swal from "sweetalert";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

import { SubTasklist } from "./Table";
import { AddsubTaskemployeeModal } from "./Modal";

export const Subtask = () => {
  const taskdetails = JSON.parse(sessionStorage.getItem("taskdetails"));
  const propertyobject = JSON.parse(sessionStorage.getItem("property"));
  const startDate = new Date(taskdetails.task_startdate);
  const endDate = new Date(taskdetails.task_enddate);
  const [showaddsubtaskModal, setshowaddsubtaskModal] = useState(false);

  const openaddsubtaskModal = () => {
    setshowaddsubtaskModal(true);
  };
  const closeaddsubtaskModal = () => {
    setshowaddsubtaskModal(false);
  };
  const { password, username } = billpunchbasicauth;

  const formattedStartDate =
    startDate.getDate() +
    " " +
    startDate.toLocaleString("default", { month: "long" });
  const formattedEndDate =
    endDate.getDate() +
    " " +
    endDate.toLocaleString("default", { month: "long" });
  let statusStyle = {};
  if (taskdetails.status === "O") {
    statusStyle = {
      backgroundColor: "rgba(255, 46, 46, 0.1)",
      color: "#ff2e2e",
      border: "1px solid #ff2e2e",
      borderRadius: ".3rem",
    };
  } else if (taskdetails.status === "P") {
    statusStyle = {
      backgroundColor: "rgba(255, 255, 0, 0.1)",
      color: "#f7b12a",
      border: "1px solid #f7b12a",
      borderRadius: ".3rem",
    };
  } else if (taskdetails.status === "C") {
    statusStyle = {
      backgroundColor: "rgba(43, 193, 85, 0.1)",
      color: "#2bc155",
      border: "1px solid #2bc155",
      borderRadius: ".3rem",
    };
  }
  let priorityIcon;
  if (taskdetails.task_priority === "High") {
    priorityIcon = <FaFlag style={{ marginRight: "5px", color: "#f4c430" }} />;
  } else if (taskdetails.task_priority === "Urgent") {
    priorityIcon = <FaFlag style={{ marginRight: "5px", color: "maroon" }} />;
  } else if (taskdetails.task_priority === "Normal") {
    priorityIcon = <FaFlag style={{ marginRight: "5px", color: "blue" }} />;
  } else if (taskdetails.task_priority === "Low") {
    priorityIcon = <FaFlag style={{ marginRight: "5px", color: "grey" }} />;
  } else if (taskdetails.task_priority === "Clear") {
    priorityIcon = (
      <img
        src={require("../../assets/images/flag_1.png")}
        style={{ marginRight: "5px", width: ".8rem" }}
      />
    );
  }
  let statusIcon;
  if (taskdetails.status === "O") {
    statusIcon = <FaExclamationCircle style={{ color: "red" }} />;
  } else if (taskdetails.status === "P") {
    statusIcon = <FaHourglassHalf style={{ color: "blue" }} />;
  } else if (taskdetails.status === "C") {
    statusIcon = <FaCheckCircle style={{ color: "green" }} />;
  }
  const [description, setDescription] = useState(taskdetails.task_description || "");
  const [rows, setRows] = useState(3);

  const handleChange = (event) => {
    setDescription(event.target.value);
    if (event.target.scrollHeight > event.target.clientHeight) {
      setRows((prevRows) => prevRows + 1);
    }
  };

  const handleFocus = () => {
    setRows(7);
  };

  const handleBlur = () => {
    if (!description) {
      setRows(3);
      setShowSubmitButton(true);
    } else {
    }
  };

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };
  const [showAllActivities, setShowAllActivities] = useState(false);

  const [activity, setActivity] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const getActivity = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        task_id: taskdetails.pk_taskid,
      });

      var requestOptions = {
        method: "POST",
       headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetRecentActivitiesSalary`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setActivity(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const getdesc = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        taskid: taskdetails.pk_taskid,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskDescripton`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data.length > 0) {
        setDescription(data.data[0].desc);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const handleDescriptionFocus = () => {
    setShowSubmitButton(true);
  };

  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [sendActivity, setSendActivity] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        taskid: taskdetails.pk_taskid,
        desc: sendActivity,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddTaskActivities`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.result, "error");
        getActivity();
      } else {
        swal("Success", data.result, "success");
        getActivity();
        setSendActivity("");
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const handleSubmitdesc = async (e) => {
    e.preventDefault();
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        taskid: taskdetails.pk_taskid,
        desc: description,
      });

      var requestOptions = {
        method: "POST",
       headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddTaskDescription`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.result, "error");
        setShowSubmitButton(false);
        getdesc();
        setRows(3);
      } else {
        swal("Success", data.result, "success");
        getdesc();
        setShowSubmitButton(false);
        setRows(3);
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  useEffect(() => {
    getActivity();
    getdesc();
  }, []);

  const { accessDataemp } = useContext(GlobalContext);
  useEffect(() => {
    // console.log("Access Data:", accessDataemp);
  }, [accessDataemp]);

  return (
    <>
      <AddsubTaskemployeeModal
        show={showaddsubtaskModal}
        closeModal={closeaddsubtaskModal}
        setshowaddsubtaskModal={setshowaddsubtaskModal}
      />
      <TaskDetailsView
        task={taskdetails}
        workspace={propertyobject}
        backTo="/Employee/Employeeworkspace"
        activityTo="/Employee/Activity"
        description={description}
        onDescriptionChange={handleChange}
        onSaveDescription={handleSubmitdesc}
        activity={activity}
        canAddSubtask={(accessDataemp || []).some(module => (module.data || []).some(role => role.role_name === "Add Subtask" && role.access === "Y"))}
        onAddSubtask={openaddsubtaskModal}
        subtasks={<SubTasklist refreshKey={showaddsubtaskModal} />}
        renderCode={code => <SyntaxHighlighter language="jsx" style={dracula}>{code}</SyntaxHighlighter>}
      />
    </>
  );
};
